__turbopack_context__.v({
  "contactForm": "ContactSection-module__5dBDVa__contactForm",
  "contactIcon": "ContactSection-module__5dBDVa__contactIcon",
  "contactIconWrapper": "ContactSection-module__5dBDVa__contactIconWrapper",
  "contactInfo": "ContactSection-module__5dBDVa__contactInfo",
  "contactInfoItem": "ContactSection-module__5dBDVa__contactInfoItem",
  "contactInfoText": "ContactSection-module__5dBDVa__contactInfoText",
  "contactInfoTitle": "ContactSection-module__5dBDVa__contactInfoTitle",
  "contactUsSection": "ContactSection-module__5dBDVa__contactUsSection",
  "contactWrapper": "ContactSection-module__5dBDVa__contactWrapper",
  "error": "ContactSection-module__5dBDVa__error",
  "form": "ContactSection-module__5dBDVa__form",
  "formGroup": "ContactSection-module__5dBDVa__formGroup",
  "formTitle": "ContactSection-module__5dBDVa__formTitle",
  "iframe": "ContactSection-module__5dBDVa__iframe",
  "input": "ContactSection-module__5dBDVa__input",
  "mapContainer": "ContactSection-module__5dBDVa__mapContainer",
  "mapOverlay": "ContactSection-module__5dBDVa__mapOverlay",
  "mapPin": "ContactSection-module__5dBDVa__mapPin",
  "pulse": "ContactSection-module__5dBDVa__pulse",
  "submitButton": "ContactSection-module__5dBDVa__submitButton",
  "textarea": "ContactSection-module__5dBDVa__textarea",
});
